<template>
  <table class="uk-table uk-table-small">
    <thead>
      <tr>
        <th>&nbsp;</th>
        <th class="uk-text-right">Netto</th>
        <th class="uk-text-right">Brutto</th>
      </tr>
    </thead>
    <tbody>
      <!--
      <tr v-if="vehicle.newprice" style="border-bottom: 1px solid #e5e5e5">
        <td class="uk-text-bold">UPE*</td>
        <td
          class="uk-text-right uk-text-bold uk-text-large uk-padding-remove-left uk-padding-small-right uk-text-nowrap"
        >
          {{ newprice | euro }}
        </td>
        <td
          class="uk-text-right uk-text-bold uk-text-large uk-padding-remove-left uk-padding-small-right uk-text-nowrap"
        >
          {{ newpriceGross | euro }}
        </td>
      </tr>
      -->
      <tr>
        <td class="uk-text-bold" v-text="modePriceLabel"></td>
        <td class="uk-text-right uk-text-bold uk-text-large uk-padding-remove-left uk-padding-small-right">
          <template v-if="showEndcustomerPrices"> {{ vehicle.salepriceEndcustomer }} € </template>

          <template v-if="showMerchantPrices"> {{ vehicle.salepriceMerchant }} € </template>

          <template v-if="mode == 'merchant'">
          <!--
            <template v-if="vehicle.houseprice > 0 && vehicle.houseprice < vehicle.salepricemerchant">
              <del class="uk-text-meta uk-text-danger">{{ vehicle.salepricemerchant | euro }}</del><br />
              {{ vehicle.houseprice | euro }}
            </template>
            <template v-else>
              -->
              {{ vehicle.salepricemerchant | euro }}
            <!--</template>-->
          </template>
        </td>

        <td class="uk-text-right uk-text-bold uk-text-large uk-padding-remove-left uk-padding-small-right">
          <template v-if="showEndcustomerPrices"> {{ vehicle.salepriceGrossEndcustomer }} € </template>

          <template v-if="showMerchantPrices"> {{ vehicle.salepriceGrossMerchant }} € </template>

          <template v-if="mode == 'merchant'">
          <!--
            <template v-if="vehicle.housepriceGross > 0 && vehicle.housepriceGross < vehicle.salepricemerchantgross">
              <del class="uk-text-meta uk-text-danger">{{ vehicle.salepricemerchantgross | euro }}</del><br />
              {{ vehicle.housepriceGross | euro }}
            </template>
            <template v-else>
              -->
              {{ vehicle.salepricemerchantgross | euro }}
            <!--</template>-->
          </template>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: ['vehicle'],

  computed: {
    ...mapGetters(['mode', 'modePriceLabel', 'showEndcustomerPrices', 'showMerchantPrices']),
    newprice() {
      return this.vehicle.newprice / 1.19
    },
    newpriceGross() {
      return this.vehicle.newprice
    }
  }
}
</script>
